"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicMediaItemSchema = void 0;
var _zod = require("zod");
var _OlapicResponseStreamItem = require("./OlapicResponseStreamItem");
/* eslint-disable @typescript-eslint/naming-convention -- external */

const olapicMediaItemSchema = exports.olapicMediaItemSchema = _zod.z.object({
  id: _zod.z.string(),
  type: _zod.z.string(),
  original_source: _zod.z.string(),
  source: _zod.z.string(),
  caption: _zod.z.string().default(''),
  video_url: _zod.z.string().nullable().default(''),
  original_image_width: _zod.z.string(),
  original_image_height: _zod.z.string(),
  images: _zod.z.object({
    mobile: _zod.z.string(),
    normal: _zod.z.string(),
    original: _zod.z.string()
  }),
  _embedded: _zod.z.object({
    uploader: _zod.z.object({
      id: _zod.z.string(),
      name: _zod.z.string()
    }),
    'streams:all': _zod.z.object({
      _embedded: _zod.z.object({
        stream: _zod.z.array(_OlapicResponseStreamItem.olapicStreamItemSchema).nullable().default([])
      })
    })
  }),
  _forms: _zod.z.object({
    report: _zod.z.object({
      action: _zod.z.object({
        href: _zod.z.string()
      })
    })
  })
});
